<script>
  import Header from '@components/Header.svelte';
  import { getAdmin } from '@lib/api/admin.js'; // ✅ 실제 login 함수 불러오기
  import { onMount } from 'svelte';

  let error = ''; // 에러 메시지 (빈 문자열이면 에러 없음)
  let AdminProfile = {};  //로그인 한 관리자 정보
  
  onMount(async () => {
    try {
      AdminProfile = await getAdmin();
    } catch (err) {
      error = err.message;
      console.error('사용자 정보 불러오기 실패:', err);
    }
  });

</script>

<div class="wrap">
  <Header userName={AdminProfile.name} />

  <section class="container">
    <section class="content">
      <slot />
    </section>
  </section>

  <footer></footer>
</div>
